module.exports = __webpack_public_path__ + "assets/air-exhaust-valve.c06ee238.svg";